import {
  IImageData,
  IMediaData,
  TProductHighlight,
  TProductTechnicalDetailsItem,
} from "../components";

export const DEMO_YOUTUBE_EMBEDID = "F3_XTK4Dzis";

export const mockedGalleryItems: IMediaData[] = [
  {
    id: "0",
    src: "assets/images/1.jpg",
    alt: "",
  },
  {
    id: "1",
    src: "assets/images/2.jpg",
    alt: "",
  },
  {
    id: "2",
    src: "assets/images/3.jpg",
    alt: "",
  },
  {
    id: "3",
    src: "assets/images/4.jpg",
    alt: "",
  },
  {
    id: "4",
    src: "assets/images/5.jpg",
    alt: "",
  },
  {
    id: "5",
    src: "assets/images/6.jpg",
    alt: "",
  },
  {
    id: "6",
    src: "assets/images/7.jpg",
    alt: "",
  },
  {
    id: "7",
    src: "assets/images/8.jpg",
    alt: "",
  },
  {
    id: "8",
    video: {
      embedId: "F3_XTK4Dzis",
      backGroundImageSrc:
        "https://i.ytimg.com/vi/F3_XTK4Dzis/maxresdefault.jpg?sqp=-oaymwEmCIAKENAF8quKqQMa8AEB-AH-CYAC0AWKAgwIABABGGUgXShRMA8=&rs=AOn4CLDPGdTkP8MLUlpRgtN1KZz1w5gP-Q",
      backGroundImageAlt: "",
    },
  },
];

export const mockedProductHighlights: TProductHighlight[] = [
  {
    id: "0",
    header: "Built for speed",
    description: "A slightly stiffer chassis to help supercharge traction.",
    iconMediaData: {
      type: "svg-icon",
      data: {
        icon: "RunningIcon",
      },
    },
  },
  {
    id: "1",
    header: "Grippy texture",
    description: "A slightly stiffer chassis to help supercharge traction.",
    iconMediaData: {
      type: "svg-icon",
      data: {
        icon: "RunningIcon",
      },
    },
  },
  {
    id: "2",
    header: "All-round performance",
    description: "A slightly stiffer chassis to help supercharge traction.",
    iconMediaData: {
      type: "svg-icon",
      data: {
        icon: "RunningIcon",
      },
    },
  },
  {
    id: "3",
    header: "Supercharged traction",
    description: "A slightly stiffer chassis to help supercharge traction.",
    iconMediaData: {
      type: "svg-icon",
      data: {
        icon: "RunningIcon",
      },
    },
  },
  {
    id: "4",
    header: "Suitable for all conditions",
    description: "A slightly stiffer chassis to help supercharge traction.",
    iconMediaData: {
      type: "svg-icon",
      data: {
        icon: "RunningIcon",
      },
    },
  },
];

export const productTechnicalDetails: TProductTechnicalDetailsItem[] = [
  {
    title: "Sport name long title in two lines:",
    description: "Running",
  },
  { title: "Running Shoe Support:", description: "Stability" },
  {
    title: "Running Shoe Cushioning:",
    description: "Maximum Cushion",
  },
  {
    title: "Heel-To-Toe Drop (Mm):",
    description: "9",
  },
  {
    title: "Footwear Height:",
    description: "Ankle",
  },
  {
    title: "One More:",
    description: "9",
  },
  {
    title: "Upper:",
    description: "Advanced Flywire synthetic",
  },
  {
    title: "Midsole:",
    description:
      "React compression-molded EVA - React Sole Technology 3-LINES-MAXIMUM",
  },
  {
    title: "Outsole:",
    description: "Rubber",
  },
  {
    title: "Weight (Pair):",
    description: "244g",
  },
  {
    title: "Gender:",
    description: "Women, Men",
  },
];

export const mockedProductStoryImages: IImageData[] = [
  {
    src: "assets/images/pdp-module.png",
  },
  { src: "assets/images/pdp-module2.png" },
];
